module.exports = __webpack_public_path__ + "static/img/partner2.a6152da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/partner2.png
// module id = ayQD
// module chunks = 0